export default {
      id: "icon-layers-usage",
      viewBox: "0 0 114.44 88.09",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-layers",
      toString: function () {
        return this.url;
      }
    }